// extracted by mini-css-extract-plugin
export var content = "index-module--content--b1552";
export var desc = "index-module--desc--9e7f0";
export var featureWrap = "index-module--featureWrap--2e132";
export var first = "index-module--first--4c93e";
export var h5Content = "index-module--h5Content--d1e19";
export var h5Item = "index-module--h5Item--bb301";
export var imgs = "index-module--imgs--0a9f2";
export var inner = "index-module--inner--c1346";
export var label = "index-module--label--4bac1";
export var left = "index-module--left--bcfc0";
export var right = "index-module--right--c54af";
export var second = "index-module--second--bea14";
export var title = "index-module--title--22a1b";